import { render } from "./SidebarElement.vue?vue&type=template&id=14e29dd4&scoped=true&bindings={\"element\":\"props\",\"isMenuExpanded\":\"props\",\"ismobile\":\"props\",\"elementBox\":\"setup\",\"elementStyle\":\"options\",\"handleClick\":\"options\",\"keyPressExpand\":\"options\"}"
import script from "./SidebarElement.vue?vue&type=script&lang=js"
export * from "./SidebarElement.vue?vue&type=script&lang=js"

import "./SidebarElement.vue?vue&type=style&index=0&lang=css"
import "./SidebarElement.vue?vue&type=style&index=1&id=14e29dd4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-14e29dd4"

export default script